<template>
  <button @click="open" class="btn btn-sm btn-success mr-1 mb-1">
    <font-awesome-icon icon="plus-circle"/>&nbsp;{{ $t('buyNew') }}
    <b-modal v-model="showForm" :title="$t('buyNew')" no-close-on-backdrop no-enforce-focus size="xl">
      <div class="alert alert-warning">
        ĐIỀU KIỆN ĐỂ TẠO ĐƯỢC ĐƠN HÀNG MUA MỚI
        <ul>
          <li>Khách hàng đang ở trạng thái dùng thử</li>
          <li>Số tài khoản hiện tại đang hoạt động cần không lớn hơn số người dùng muốn mua</li>
          <li>Số dư trong tài khoản trừ đi số tiền cần thanh toán lớn hơn hạn mức</li>
        </ul>
        CÁC LƯU Ý KHÁC:
        <ul>
          <li>Nếu khách hàng đã có nhân viên sales thì không cần chọn nhân viên sales</li>
          <li>Nếu nhân viên sales được chọn khác với nhân viên sales đang gắn với khách hàng, đơn hàng này sẽ được tính cho nhân viên sales được chọn, đồng thời nhân viên được chọn sẽ được gắn chăm sóc khách hàng này</li>
        </ul>
      </div>
      <div class="modal-content">
        <div class="modal-body">
          <form>
            <div class="row">
              <div class="col-md">
                <client-select v-if="showForm" :label="$t('client')" :model="formModel" attribute="client"
                               :errors="formErrors"></client-select>
                <div v-if="getClientLoading" class="text-center">
                  <b-spinner></b-spinner>
                </div>
                <div v-else-if="client">
                  <p>
                    <span>{{ $t('sales') }}</span>:
                    <b>{{ client.populatedSales ? client.populatedSales.name : $t('noSales') }}</b>
                  </p>
                  <p><span>{{ $t('currentUserCount') }}</span>: <b>{{ client.userCount }}</b></p>
                  <p><span>{{ $t('expireTime') }}</span>: <b>{{ client.expireTime | moment('DD/MM/YYYY HH:mm:ss') }}</b></p>
                  <p><span>{{ $t('creditBalance') }}</span>: <b>{{ client.creditBalance | numFormat }}</b></p>
                  <p><span>{{ $t('creditLimit') }}</span>: <b>{{ client.creditLimit | numFormat }}</b></p>
                  <p>
                    <span v-if="client.isTrial" class="badge badge-warning">{{$t('isTrial')}}</span>
                    <span v-else class="badge badge-danger">{{$t('isNotTrial')}}</span>
                  </p>
                </div>
              </div>
              <div class="col-md">
                <admin-user-select :label="$t('sales')" :model="formModel" attribute="sales" :errors="formErrors"
                                   :place-holder="$t('chooseSale')" v-if="formModel.client"></admin-user-select>
                <form-select :label="$t('choosePlan')" :model="formModel" attribute="plan" :errors="formErrors"
                             :options="planOptions"></form-select>
                <form-input :label="$t('userPrice')" attribute="userPrice" :model="formModel" :errors="formErrors"
                            disabled="true"></form-input>
                <form-input :label="$t('numberOfUser')" attribute="userLimit" :model="formModel"
                            :errors="formErrors"></form-input>
                <form-input :label="$t('numberOfMonthToBuy')" attribute="monthCount" :model="formModel"
                            :errors="formErrors"></form-input>
              </div>
              <div class="col-md">
                <form-date-time :label="$t('startDate')" attribute="startDate" :model="formModel" :errors="formErrors"
                                format="DD/MM/YYYY"></form-date-time>
                <form-input :label="$t('discount')" attribute="discountAmount" :model="formModel"
                            :errors="formErrors"></form-input>
                <form-input :label="$t('numberOfDayGifted')" attribute="numberOfDayGifted" :model="formModel"
                            :errors="formErrors"></form-input>
                <form-input :label="$t('numberOfUserGifted')" attribute="numberOfUserGifted" :model="formModel"
                            :errors="formErrors"></form-input>
                <form-input :label="$t('agencyCommission')" attribute="agencyCommission" :model="formModel"
                            :errors="formErrors"></form-input>
                <form-input :label="$t('note')" attribute="note" :model="formModel" :errors="formErrors"></form-input>
              </div>
            </div>
          </form>
          <template v-if="client">
            <hr class="is-primary">
            <div class="row">
              <div class="col-7 col-md-6 offset-md-2 text-right">{{ $t("expireTime") }}:</div>
              <div class="col-5 col-md-4 text-right">
                <b v-if="expireTime">{{ expireTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
                <b v-else>{{$t('noExpireTime')}}</b>
              </div>
            </div>
            <div class="row">
              <div class="col-7 col-md-6 offset-md-2 text-right">{{ $t("total") }}:</div>
              <div class="col-5 col-md-4 text-right">
                <b>{{ total | numFormat }}</b>
              </div>
            </div>
          </template>
        </div>
      </div>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button :disabled="!formModel.plan || !formModel.client || !['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)"
                class="btn btn-primary float-right"
                @click="purchase()">
          {{ $t('savePlanOrder') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>
import CRUD from "@/mixins/CRUD";
import ClientSelect from "../../../components/ClientSelect";
import AdminUserSelect from "../../../components/AdminUserSelect";
import moment from "moment";

export default {
  components: {AdminUserSelect, ClientSelect},
  props: ['clientId'],
  mixins: [CRUD],
  data: function () {
    return {
      service: '/plan-order',
      defaultFormModel: {
        client: this.clientId ? this.clientId : null,
        plan: null,
        userLimit: 10,
        startDate: Date.now(),
        monthCount: 12,
        userPrice: 0,
        discountAmount: 0,
        numberOfDayGifted: 0,
        numberOfUserGifted: 0,
        sales: null,
        agencyCommission: 0
      },
      plans: [],
      planOptions: [{value: null, text: this.$t('choosePlan')}],
      sales: null,
      supervisor: null,
      manager: null,
      getSupervisorLoading: false,
      getManagerLoading: false,
      client: null,
      getClientLoading: false,
    }
  },
  methods: {
    getPlans() {
      this.planOptions = [{value: null, text: this.$t('choosePlan')}];
      this.$service.get("/plan", {
        params: {
          page: 1,
          pageSize: 100,
          unlimitedUser: 0
        }
      }).then(response => {
        this.plans = response.data.docs;
        response.data.docs.forEach(item => {
          this.planOptions.push({
            value: item._id,
            text: item.name,
            userPrice: item.userPrice ? item.userPrice : 0,
            unlimitedUser: item.unlimitedUser}
          );
        });
      });
    },
    open: function () {
      this.getPlans();
      this.showForm = true;
      this.formModel = {};
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
      if (this.clientId) {
        this.getClient();
      }
    },
    purchase() {
      let loader = this.$loading.show();
      this.$service({url: '/plan-order/buy-new/', method: 'post', data: this.formModel}).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
          this.$bus.$emit('planOrder');
          this.$bus.$emit('loadClient');
          this.showForm = false;
        } else {
          this.$swal({
            title: this.$t('error'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    getClient() {
      this.$service.get('/client/' + this.formModel.client).then(response => {
        if (response) {
          this.client = response.data;
        }
      }).finally(() => {
        this.getClientLoading = false;
      })
    },
  },
  watch: {
    "formModel.client": {
      handler(val) {
        if (this.showForm && val) {
          this.getClientLoading = true;
          this.getClient();
        } else {
          this.client = null
        }
      }
    },
    "formModel.plan": {
      handler() {
        if (this.formModel.plan) {
          let plan = this.planOptions.find(p => p.value === this.formModel.plan);
          if (plan) {
            this.formModel.userPrice = plan.userPrice ? plan.userPrice : 0;
          } else {
            this.formModel.userPrice = 0;
          }
        } else {
          this.formModel.userPrice = 0;
        }
      }
    },
    "client": {
      handler(val) {
        if (val) {
          this.getPlans();
        } else {
          this.getClientLoading = false;
        }
      }
    },
  },
  computed: {
    total() {
      return this.formModel.userPrice * this.formModel.monthCount * this.formModel.userLimit - this.formModel.discountAmount
    },
    expireTime() {
      let result = 0;
      if (this.formModel.client && this.formModel.startDate && this.formModel.monthCount && parseInt(this.formModel.monthCount) > 0) {
        result = moment(this.formModel.startDate).endOf('day').add(this.formModel.monthCount,'month');
        if (parseInt(this.formModel.numberOfDayGifted) > 0) {
          result = moment(result).add(this.formModel.numberOfDayGifted, 'day')
        }
      }
      return result
    }
  },
  i18n: {
    messages: {
      vi: {
        buyNew: 'Mua mới gói dịch vụ',
        choosePlan: 'Chọn gói dịch vụ',
        userPrice: 'Giá/user/tháng',
        numberOfUser: 'Số user',
        numberOfMonthToBuy: 'Số tháng',
        expireTime: 'Ngày hết hạn',
        note: 'Ghi chú',
        total: 'Thành tiền',
        cancel: 'Huỷ',
        savePlanOrder: 'Lưu đơn hàng',
        discount: 'Số tiền giảm giá',
        numberOfDayGifted: 'Số ngày tặng thêm',
        numberOfUserGifted: 'Số user tặng thêm',
        sales: 'Nhân viên sales',
        noSales: 'Không có nhân viên sales',
        supervisor: 'Trưởng nhóm',
        noSupervisorFound: 'Không tìm thấy trưởng nhóm',
        manager: 'Trưởng phòng',
        noManagerFound: 'Không tìm thấy trưởng phòng',
        chooseSale: 'Chọn nhân viên sales',
        agencyCommission: 'Hoa hồng cho đại lý',
        startDate: 'Tính từ ngày',
        currentUserCount: 'Số tài khoản đang hoạt động',
        isNotTrial: 'Không phải tài khoản dùng thử'
      },
      en: {
        buyNew: 'Buy new',
        choosePlan: 'Choose plan',
        userPrice: 'Price/user/month',
        numberOfUser: 'Number of user',
        numberOfMonthToBuy: 'Number of month',
        expireTime: 'Expire time',
        note: 'Note',
        total: 'Total',
        cancel: 'Cancel',
        savePlanOrder: 'Save plan order',
        discount: 'Discount amount',
        numberOfDayGifted: 'Number of day gifted',
        numberOfUserGifted: 'Number of user gifted',
        sales: 'Sales person',
        noSales: 'No sales person',
        supervisor: 'Supervisor',
        noSupervisorFound: 'No supervisor found',
        manager: 'Manager',
        noManagerFound: 'No manager found',
        chooseSale: 'Select pos person',
        agencyCommission: 'Commission for agency',
        startDate: 'Start date',
        currentUserCount: 'Current user count',
        isNotTrial: 'Is not trial'
      }
    }
  }
}
</script>